import React from "react";
import styled from "styled-components";

const Container = styled.div`
    .list-group-item {
        color: var(--mid-font-color);
        background-color: var(--light-background-color);
        transition: color 0.5s, background-color 0.5s;
    }

    .list-group-item:hover {
        color: var(--dark-background-color);
        background-color: var(--light-font-color);
    }
`;

const SectionNavItem = ({ name, href }) => (
    <Container>
        <a href={href} class="list-group-item list-group-item-action">
            {name}
        </a>
    </Container>
);

export default SectionNavItem;
